import { createSelector } from '@reduxjs/toolkit';
import { ObjectOfAny } from '../reducers/types';
import { RootState } from '../store/store';

const QuestionValidationRuleProjections = {} as ObjectOfAny;

QuestionValidationRuleProjections.filteredRulesByCodes = (
    codes: ObjectOfAny[],
) =>
    createSelector(
        (state: RootState) =>
            state.questionValidationRule.questionValidationRule.byId,
        rulesById => {
            if (!codes || !rulesById) {
                // Handle the case when rulesById is null
                return [];
            }

            return Object.values(rulesById).filter(rule =>
                Object.keys(codes).includes(rule.code),
            );
        },
    );

export default QuestionValidationRuleProjections;
